export default "__VITE_ASSET__7ffa40f3__"